import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WelcomeComponent } from './welcome.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
    { path: 'welcome', component: WelcomeComponent },
])
  ],
  exports: [RouterModule]
})
export class WelcomeRoutingModule { }
